import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const fetchOrders = createAction(Constants.FETCH_ORDERS.REQUEST);
export const fetchTransactionOrders = createAction(Constants.FETCH_TRANSACTION_ORDERS.REQUEST);
export const updateTransactionOrders = createAction(Constants.UPDATE_TRANSACTION_ORDERS, payload => payload);
export const clearTransactionOrderState = createAction(Constants.FETCH_TRANSACTION_ORDERS_CLEAR_STATE);
export const fetchOrderCount = createAction(Constants.FETCH_ORDER_COUNT.REQUEST, filter => filter);
export const fetchOrderStats = createAction(Constants.FETCH_ORDER_STATS.REQUEST);
export const fetchServices = createAction(Constants.FETCH_SERVICES.REQUEST);